import { Link } from "react-router-dom";
import MagneticButton from "@/components/ui/MagneticButton";
import HeroBrain from "@/components/3d/HeroBrain";

export default function NotFound() {
  return (
    <div className="min-h-[90vh] flex flex-col items-center justify-center px-6 text-center">
      <div className="h-[300px] w-full max-w-[500px] relative pointer-events-none mb-8">
        <HeroBrain />
      </div>
      <h1 className="font-heading text-6xl text-nilyTeal mb-2">404</h1>
      <h2 className="text-2xl text-white mb-6">Signal Lost</h2>
      <p className="text-slate-400 max-w-md mx-auto mb-8">The neural pathway you are looking for does not exist.</p>
      <Link to="/"><MagneticButton>Return to Core</MagneticButton></Link>
    </div>
  );
}
